import "./_price-impact-value.scss";

import {decimalToPercent, formatNumber} from "../../core/util/number/numberUtils";
import Badge from "../badge/Badge";
import {getPriceImpactComponentProps} from "./utils/PriceImpactValue.utils";
import Typography from "../typography/Typography";

interface PriceImpactValueProps {
  /** In decimal format (e.g. for 50%, `priceImpact` should be `0.05`).
   * `priceImpact` value returned from the SDK can be used directly
   */
  priceImpact: number;
}

const percentageFormatter = formatNumber({
  maximumFractionDigits: 2,
  minimumFractionDigits: 0,
  style: "percent"
});

/**
 * Renders the price impact label ("Fair", "Normal", or "Expensive") and the price impact percentage
 */
function PriceImpactValue({priceImpact}: PriceImpactValueProps) {
  const priceImpactPercentage = decimalToPercent(priceImpact);
  const {priceLabel, badgeType, color} =
    getPriceImpactComponentProps(priceImpactPercentage);

  return (
    <div className={"price-impact-value"}>
      <Typography textColor={color} fontWeight={"bold"}>
        {priceLabel}
      </Typography>

      <Badge type={badgeType}>{percentageFormatter(priceImpact)}</Badge>
    </div>
  );
}

export default PriceImpactValue;
